import React from 'react';
import ReactDOM from 'react-dom'; // the little robot that handles the dom/the glue of web
import './index.css'; //React allows css customization to individual components
import registerServiceWorker from './registerServiceWorker'; //allows faster apps and potential  to work offline
import 'tachyons';
import App from './container/App';


ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js